import { Stack } from '@mui/material'
import type { CustomerExistingValuation as ExistingValuation } from '@einwert/valuation-api-client'
import {
    CardItem,
    BlockMath,
    getFormattedValueAndUnitFromNumber,
    getFormattedValueAndUnitFromPercentage,
    KeyValueBox,
    tokens,
} from 'ComponentLibrary'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type IncomeRatesKeyValueCardItemsProps = {
    valuation: ExistingValuation
}

export default function IncomeRatesKeyValueCardItems({ valuation }: IncomeRatesKeyValueCardItemsProps) {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tAllValues } = useTranslation('terminology', { keyPrefix: 'export.allValues' })
    const locale = useCurrentResolvedLocale()
    const { t: tValuationIncomePage } = useTranslation('pages', {
        keyPrefix: 'assets.assetDetails.valuation.valuationIncomePage',
    })

    return (
        <Stack direction="row" gap={tokens.SizingSpacing300}>
            <CardItem>
                <KeyValueBox
                    label={tCommon('grossInitialYield')}
                    info={<BlockMath math={tValuationIncomePage('formulas.grossInitialYield')} />}
                    {...getFormattedValueAndUnitFromPercentage(valuation.gross_initial_yield, undefined, locale)}
                />
            </CardItem>
            <CardItem>
                <KeyValueBox
                    label={tCommon('grossYield')}
                    info={<BlockMath math={tValuationIncomePage('formulas.grossYield')} />}
                    {...getFormattedValueAndUnitFromPercentage(valuation.gross_yield, undefined, locale)}
                />
            </CardItem>
            <CardItem>
                <KeyValueBox
                    label={tAllValues('rows.grossYieldMultiplier')}
                    info={<BlockMath math={tValuationIncomePage('formulas.grossYieldMultiplier')} />}
                    {...getFormattedValueAndUnitFromNumber(valuation.gross_yield_multiplier, undefined, undefined, locale)}
                />
            </CardItem>
            <CardItem>
                <KeyValueBox
                    label={tAllValues('rows.netYieldMultiplier')}
                    info={<BlockMath math={tValuationIncomePage('formulas.netYieldMultiplier')} />}
                    {...getFormattedValueAndUnitFromNumber(valuation.net_yield_multiplier, undefined, undefined, locale)}
                />
            </CardItem>
        </Stack>
    )
}
